export const DAO_CODE = 'PENNYLANE' + '_DAO';
